// extracted by mini-css-extract-plugin
export var filterIncDec = "_c8-0";
export var leftBorder = "_c8-1";
export var rightBorder = "_c8-2";
export var stringInput = "_c8-3";